// ** React Imports
import React, { useEffect, useState } from 'react'

// ** Redux Imports
import { useSelector } from 'react-redux'

// ** Styles Imports
import styles from './styles.module.css'

// ** Component Imports
import TableButton from '../../../../components/TableButton/TableButton'
import MUIDatagrid from '../../../../components/MUIDatagrid/MUIDatagrid'
import CoinDisplay from '../../../../components/CoinDisplay/CoinDisplay'

// ** Utils Imports
import { handleStakingSubscribe } from '../../helpers/handleStakingSubscribe'

// ** API Imports
import { _getStakingDurations } from '../../redux/actions'

function StakingTable({ rows = [], setRows, loading = false }) {
  // ** States
  const [durationOptions, setDurationOptions] = useState([])

  // ** Table Columns
  const columns = [
    {
      field: 'id',
      headerName: 'Coin',
      minWidth: 245,
      editable: false,
      flex: 1,
      renderCell: ({ row }) => <CoinDisplay useReduxStore coinId={row.asset.toLowerCase()} coinTag={row.tags[0]} />
    },
    {
      field: 'apr',
      headerName: 'APR',
      minWidth: 105,
      editable: false,
      flex: 1,
      renderCell: ({ row }) => {
        const apr = row.period_summary_list.find(period => period.duration === row.selectedPeriod.duration).apr
        return <>{apr}%</>
      }
    },
    {
      field: 'durations',
      headerName: 'Durations (Days)',
      minWidth: 325,
      editable: false,
      flex: 1,
      renderCell: ({ row, api }) => (
        <div className={styles.durationsContainer}>
          {row.period_summary_list.map((product, index) => (
            <button
              key={index}
              value={product.duration}
              className={`${styles.durationButton} ${
                row.selectedPeriod.duration === product.duration && styles.selectedDurationButton
              }`}
              onClick={() => {
                const updatedRows = rows.map(r => {
                  if (r.asset === row.asset) {
                    return { ...r, selectedPeriod: product }
                  }
                  return r
                })
                setRows(updatedRows)
              }}
            >
              {product.duration !== 0 ? product.duration : 'Flexible'}
            </button>
          ))}
        </div>
      )
    },
    {
      headerName: 'Action',
      minWidth: 125,
      flex: 1,
      renderCell: ({ row }) => (
        <TableButton
          buttonText='Subscribe'
          style={{ background: 'var(--primary-color)', color: 'var(--text-color-inverted)' }}
          onClick={() => handleSubscribeClick(row)}
        />
      )
    }
  ]

  // Get the duration options from API
  const fetchDurations = () => {
    // _getStakingDurations(
    //   res => setDurationOptions(res.data),
    //   err => console.error('Error while fetching staking durations')
    // )
  }

  // Handle Subscribe button click in the staking table
  const handleSubscribeClick = stakingProduct => {
    handleStakingSubscribe(stakingProduct)
  }

  useEffect(() => {
    // Fetch duration on load
    fetchDurations()
  }, [])

  return (
    <>
      <MUIDatagrid
        hideFooter
        disableSorting
        columns={columns}
        loading={loading}
        rows={rows}
        getRowId={row => row.asset}
      />
    </>
  )
}

export default StakingTable
